import "./Login.scss";

import axios from "axios";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import MonadModal from "ui/build/components/Modal/MonadModal";
import * as Yup from "yup";

import fetchEnv from "../../utils/FetchEnv";
import { t } from "../../utils/ResourceUtils";
import { Timer } from "./Timer";

const required = t("cm.please_fill_this_field");
const tooLong = t("cm.too_long");
const tooShort = t("cm.too_short");

const userData = {
  email: "",
  securityAnswer1: "",
  securityAnswer2: "",
  securityAnswer3: "",
};

const defaultResetPasswordData = {
  email: "",
  password: "",
  confirmPassword: "",
};

export const authServicesResponseHandler = ({ userRegister, setSecurityData, handleVerifyClick, securityData }) => {
  if (userRegister && userRegister.status === 200) {
    setSecurityData(userData);
    handleVerifyClick(securityData);
  }
};

export const authServicesCatchHandler = ({ handlePasswordResetModal, handleVerifyClick, securityData, err }) => {
  handlePasswordResetModal?.(false);
  handleVerifyClick(securityData, err.response?.data?.message);
};

function PasswordResetModal({ open, handlePasswordResetModal, handleVerifyClick }) {
  const [securityData, setSecurityData] = useState(userData);
  const tenantId = localStorage.getItem("tenantId");

  const handleChangeFun = (e, setFieldValue) => {
    const securityData_ = { ...securityData };
    securityData_[e.target.name] = e.target.value;
    setSecurityData(securityData_);
    setFieldValue(e.target.name, e.target.value);
  };

  const handleSecurityQuestionsVerify = async (data) => {
    const reqBody = {
      tenantID: tenantId,
      securityQuestion1: t("cm.what_is_your_pet_name"),
      securityQuestion2: t("cm.what_is_your_place_of_birth"),
      securityQuestion3: t("cm.what_is_your_first_job"),
      ...data,
    };
    const reqHeaders = {
      headers: {
        "Accept-Language": "en",
        payload: JSON.stringify(reqBody),
      },
    };
    try {
      const userRegister = await axios.post(
        `${fetchEnv()?.REACT_APP_APIURL_ADMIN}/authservice/v1/users/${data.email}`,
        {},
        { ...reqHeaders }
      );
      authServicesResponseHandler({ userRegister, setSecurityData, handleVerifyClick, securityData });
    } catch (err) {
      authServicesCatchHandler({ handlePasswordResetModal, handleVerifyClick, securityData, err });
    }
  };

  const securityQuestionsValidationSchema = Yup.object().shape({
    email: Yup.string().email(t("cm.invalid_email")).required(t("cm.email_is_required_exclamation")),
    securityAnswer1: Yup.string().min(2, tooShort).max(50, tooLong).required(required),
    securityAnswer2: Yup.string().min(2, tooShort).max(50, tooLong).required(required),
    securityAnswer3: Yup.string().min(2, tooShort).max(50, tooLong).required(required),
  });

  const handleCancel = () => {
    handlePasswordResetModal?.(false);
  };
  return (
    <>
      <MonadModal
        className="password-reset-form-modal"
        variant="regular-modal"
        size="md"
        open={open}
        onCancel={handleCancel}
        heading={t("cm.please_answer_the_following_security_questions")}
        body={
          <>
            <Formik
              initialValues={{ ...userData }}
              validationSchema={securityQuestionsValidationSchema}
              onSubmit={(data) => {
                handleSecurityQuestionsVerify(data);
              }}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form>
                  <div className="row w-100">
                    <div className="col-12 pr-0">
                      <div className="lpt-5">{t("cm.email_ID")}</div>
                      <Field
                        name="email"
                        type="email"
                        variant="outlined"
                        autoComplete="off"
                        ismandatory="true"
                        value={values.email}
                        data-testid="email"
                        onChange={(e) => handleChangeFun(e, setFieldValue)}
                      />
                      {errors.email && touched.email ? <div className="df-error-message">{errors.email}</div> : null}
                      <div className="lpt-5">{t("cm.what_is_your_pet_name")}</div>
                      <Field
                        type="text"
                        name="securityAnswer1"
                        variant="outlined"
                        value={values.securityAnswer1}
                        data-testid="securityAnswer1"
                        onChange={(e) => handleChangeFun(e, setFieldValue)}
                        ismandatory="true"
                      />
                      {errors.securityAnswer1 && touched.securityAnswer1 ? (
                        <div className="df-error-message">{errors.securityAnswer1}</div>
                      ) : null}
                      <div className="lpt-5">{t("cm.what_is_your_birth_place")}</div>
                      <Field
                        type="text"
                        name="securityAnswer2"
                        variant="outlined"
                        value={values.securityAnswer2}
                        data-testid="securityAnswer2"
                        onChange={(e) => handleChangeFun(e, setFieldValue)}
                        ismandatory="true"
                      />
                      {errors.securityAnswer2 && touched.securityAnswer2 ? (
                        <div className="df-error-message">{errors.securityAnswer2}</div>
                      ) : null}
                      <div className="lpt-5">{t("cm.what_is_your_first_job")}</div>
                      <Field
                        type="text"
                        name="securityAnswer3"
                        variant="outlined"
                        value={values.securityAnswer3}
                        data-testid="securityAnswer3"
                        onChange={(e) => handleChangeFun(e, setFieldValue)}
                        ismandatory="true"
                      />
                      {errors.securityAnswer3 && touched.securityAnswer3 ? (
                        <div className="df-error-message">{errors.securityAnswer3}</div>
                      ) : null}
                      <div className="verify-btn mt-16">
                        <button type="submit">{t("cm.verify")}</button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </>
        }
      />
    </>
  );
}

export default PasswordResetModal;

export const ResetPasswordModel = ({ open, handleNewPasswordReset, data }) => {
  const [resetPasswordData, setResetPasswordData] = useState({ ...defaultResetPasswordData, email: data?.email });
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState({
    alertType: "",
    message: "",
  });

  const handlePasswordChange = (e, setFieldValue) => {
    const resetPasswordData_ = { ...resetPasswordData };
    resetPasswordData_[e.target.name] = e.target.value;
    setResetPasswordData(resetPasswordData_);
    setFieldValue(e.target.name, e.target.value);
  };

  const validatePassword = (str) => {
    const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[^\w\s]).{8,16}$/;
    return regex.test(str);
  };
  const handleNewpassModalSubmit = async () => {
    if (validatePassword(resetPasswordData.password)) {
      if (resetPasswordData.password === resetPasswordData.confirmPassword) {
        try {
          const resetResp = await axios.patch(
            `${fetchEnv()?.REACT_APP_APIURL_ADMIN}/authservice/v1/users/${resetPasswordData.email}`,
            {},
            {
              headers: {
                "Accept-Language": "en",
                newPassword: resetPasswordData.password,
              },
            }
          );
          if (resetResp?.status === 200) {
            handleNewPasswordReset();
          }
        } catch (error) {
          handleNewPasswordReset(error.response?.data?.message);
        }
      } else {
        setShowAlert(true);
        setAlert({
          alertType: "danger",
          message: "Passwords doesn't match!",
        });
      }
    } else {
      setShowAlert(true);
      setAlert({
        alertType: "danger",
        message: `password must contain
            at least minimum 8 characters,
            at least 1 uppercase letter,
            at least 1 lowercase letter,
            at least 1 digit and
            1 special character consists of (~!@#$%^*_+=.&)`,
      });
    }
  };
  const passwordResetModal = Yup.object().shape({
    email: Yup.string().email(t("cm.invalid_email")).required(t("cm.email_is_required_exclamation")),
    password: Yup.string().min(8, tooShort).max(17, tooLong).required(required),
    confirmPassword: Yup.string().min(8, tooShort).max(17, tooLong).required(required),
  });

  const handleTimeOut = () => {
    handleNewPasswordReset();
  };

  return (
    <>
      <MonadModal
        className="password-reset-form-modal"
        variant="regular-modal"
        size="md"
        open={open}
        onCancel={handleNewPasswordReset}
        heading={"Create New Password"}
        body={
          <>
            <Formik
              initialValues={{
                ...resetPasswordData,
              }}
              validationSchema={passwordResetModal}
              onSubmit={() => {
                handleNewpassModalSubmit();
              }}
            >
              {({ errors, touched, values, setFieldValue }) => {
                return (
                  <Form>
                    <div className="row w-100">
                      <Timer expiresIn={300} handleTimeOut={handleTimeOut} />
                      <div className="col-12 pr-0">
                        <div className="lpt-5">{t("cm.email_ID")}</div>
                        <Field
                          name="email"
                          type="email"
                          variant="outlined"
                          autoComplete="off"
                          ismandatory="true"
                          value={values.email}
                          disable="true"
                          data-testid="emailid"
                          onChange={(e) => handlePasswordChange(e, setFieldValue)}
                        />
                        {errors.email && touched.email ? <div className="df-error-message">{errors.email}</div> : null}
                        <div className="lpt-5">{t("cm.password")}</div>
                        <Field
                          type="password"
                          name="password"
                          variant="outlined"
                          value={values.password}
                          data-testid="password"
                          onChange={(e) => handlePasswordChange(e, setFieldValue)}
                          ismandatory="true"
                        />
                        {errors.password && touched.password ? (
                          <div className="df-error-message">{errors.password}</div>
                        ) : null}
                        <div className="lpt-5">{t("cm.confirm_password")}</div>
                        <Field
                          type="password"
                          name="confirmPassword"
                          variant="outlined"
                          value={values.confirmPassword}
                          data-testid="confirmPassword"
                          onChange={(e) => handlePasswordChange(e, setFieldValue)}
                          ismandatory="true"
                        />
                        {errors?.confirmPassword && touched?.confirmPassword ? (
                          <div className="df-error-message">{errors?.confirmPassword}</div>
                        ) : null}
                        <div className="verify-btn mt-16">
                          <button type="submit">{t("cm.submit")}</button>
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
            {showAlert ? <div className="df-error-message"> {alert.message} </div> : null}
          </>
        }
      />
    </>
  );
};
